import PlatformError from "../PlatformError";

export default new PlatformError(
  "WARN",
  "You have previously completed this study.",
  "Warning",
  "User attempted to resume a completed study",
  "app.error.previoussuccess"
);
